/**
 * Event 时间轴设计稿 rem 换算比例（1 设计 rem = N px）
 * 修改此值后，Event 组件会通过 CSS 变量 --event-rem-ratio 同步缩放
 * 请同步更新 src/styles/event-design.scss 中的 $event-design-rem-ratio
 */
export const EVENT_DESIGN_REM_RATIO = 9
